module.exports = __webpack_public_path__ + "img/tapic6.dc79a193.png";